/* Akoya Größentabelle – öffnet/schließt das Overlay. */
(function () {
  if (window.__akoyaSizeChartInit) return;
  window.__akoyaSizeChartInit = true;

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-size-chart-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-size-chart-open'));
      if (dialog) {
        event.preventDefault();
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      }
      return;
    }

    var closer = event.target.closest('[data-size-chart-close]');
    if (closer) {
      var openDialog = closer.closest('dialog');
      if (openDialog) {
        event.preventDefault();
        if (typeof openDialog.close === 'function') {
          openDialog.close();
        } else {
          openDialog.removeAttribute('open');
        }
      }
      return;
    }

    var target = event.target;
    if (target.tagName === 'DIALOG' && target.classList.contains('akoya-size-chart__dialog')) {
      target.close();
    }
  });
})();